import request from "@/utils/requestSC";

// 店铺详情
export async function detail(params) {
  return request.post("/rest/shopDetail/detail", params);
}
// 导航
export async function getShopZXInfoByShopId(params) {
  return request.post("/shopInfo/getShopZXInfoByShopId.do", params);
}
// 获取全部货品
export async function shopGoodsNew(params) {
  return request.post("/mob/shop/shopGoodsNew", params);
}
// 全部分类
export async function categoryList(params) {
  return request.post("/mob/shop/commodityClassificationList", params);
}
// 最新上架 促销
export async function shopIndex(params) {
  return request.post("/mob/shop/shopIndex", params);
}

export async function getBoIdByShopId(params) {
  return request.get("/mob/shop/getBoIdByShopId", params);
}
